module.exports = __webpack_public_path__ + "img/贝雷帽.6e875dfa.png";